import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

function NavbarDropdown() {
    const navigate = useNavigate();

    const logOutUser = () => {
        if (window.confirm("Are you sure you want to log out?")) {
            localStorage.clear();
            sessionStorage.clear();
            navigate('/login');
            console.log("User logged out successfully.");

        } else {
            console.log("User cancelled the logout action.");
        }
    }

    return (<>
        <Dropdown>
            <Dropdown.Toggle variant="transparent" className="dropdown-basic p-0 d-flex align-items-center userTitle">
                <span className="userIcon mx-1"><i className="bi bi-person-fill"></i></span>
                <div className="me-2">Me</div>
            </Dropdown.Toggle>

            {<Dropdown.Menu>
                <Dropdown.Item className="fo-s2" as={Link} to={"/profile"}>Profile</Dropdown.Item>
                <hr className="m-0" />
                <Dropdown.Item className="fo-s2" onClick={logOutUser}>Log Out</Dropdown.Item>
            </Dropdown.Menu>}
        </Dropdown>
    </>);
}

export default NavbarDropdown;
